import { render, staticRenderFns } from "./UpcomingRents.vue?vue&type=template&id=0c52bfba&"
import script from "./UpcomingRents.vue?vue&type=script&lang=js&"
export * from "./UpcomingRents.vue?vue&type=script&lang=js&"
import style0 from "./UpcomingRents.vue?vue&type=style&index=0&lang=css&"
import style1 from "./UpcomingRents.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports